import React from 'react'

export interface ChartHeaderProps {
  header1: string
  header2: string
}

export default function ChartHeader({ header1, header2 }: ChartHeaderProps) {
  return (
    <>
      <div className='table-headline'>
        <span className='text-bold text-big text-headline'>{header1}</span>
        <span className=''>{header2}</span>
      </div>
      {/* <br /> */}
    </>
  )
}
